var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkItem",on:{"click":_vm.checkedItem}},[_c('span',{staticClass:"item icon"},[_c('div',{staticClass:"colorCheck",style:({'background':_vm.checked?_vm.color:'transparent'})})]),_c('span',{staticClass:"item label"},[_vm._v(" "+_vm._s(_vm.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }